// Page
export const RESOLVE_SLUG = 'RESOLVE_SLUG';
export const RESOLVE_SLUG_SUCCESS = 'RESOLVE_SLUG_SUCCESS';
export const RESOLVE_SLUG_ERROR = 'RESOLVE_SLUG_ERROR';
